import {Inject, Injectable} from '@angular/core';
import {environment} from "../../environments/environment";

declare const gtag: Function;

@Injectable({
    providedIn: 'root'
})
export class MetricsService {

    public window: Window;

    constructor(
        @Inject('Window') window: Window) {
        this.window = window;
    }

    public initGA( ) {
        if ( environment.enableGA && typeof gtag === 'function' ) {
            gtag('config', environment.gaTrackingId);
        }
    }

    public logMetric(metric: any) {
        switch ( environment.logLevel ) {
            case 'FATAL':
                break;
            case 'ERROR':
                break;
            case 'WARN':
                break;
            case 'INFO':
                break;
            case 'DEBUG':
            case 'TRACE':
                console.log(metric.name + ": " + metric.value, metric.obj );
        }
    }

}
